export const EXTRA_TEASER_FIELD_OPTIONS = [
    { value: 'itemUrl', name: 'Itinerary Link' },
];
